<template>
  <div class="indexBg">
    <div class="logoCss">
      <img src="@/assets/logo.png" />
    </div>
    <div class="btnDiv">
      <img class="hand" src="@/assets/index.png" />
      <img class="hand" src="@/assets/down.png" @click="copyLike()" />
      <div class="more-service">
        <span>更多服务 <i class="el-icon-arrow-down"></i></span>
        <!-- 下拉菜单 -->
        <div class="service-dropdown">
          <a target="_blank" href="https://www.nyackuajing.com/">综合平台</a>
          <a target="_blank" href="https://wm.nyackuajing.com/">跨境出海</a>
          <a target="_blank" href="http://ai.nyackuajing.com/">AI智能</a>
          <a target="_blank" href="http://acxy.nyackuajing.com/">人才培育</a>
        </div>
      </div>
    </div>
    <div class="bannerDiv">
      <div class="bLeft">
        <img src="@/assets/name.png" />
        <p>打破语言壁垒<br />让世界“语”你同行。</p>
        <div>多语互译·学习辅助·AI 润色</div>
      </div>
      <div class="bRight">
        <img src="@/assets/ip.png" />
      </div>
    </div>
    <div class="formDiv divCss">
        <div class="formLeft formSub">
          <div class="fInp"><input type="number" v-model="phone" placeholder="请输入手机号"></div>
          <div class="fInp codeInp">
            <input type="number" v-model="codeVal" placeholder="请输入验证码">
            <div class="codeDiv">
              <span v-if="!getCodeBlo" class="code hand" @click="getCode()">发送验证码</span>
              <span v-else-if="getCodeBlo && getCodeNum >= 1" class="code">{{ getCodeNum }}秒后获取</span>
              <span v-else-if="getCodeBlo && getCodeNum < 1" class="code hand" @click="getCode()">重新获取</span>
              <span v-else class="code">{{ count }}s</span>
            </div>
          </div>
          <div class="fInp"><input type="text" v-model="pwd" placeholder="请输入密码"></div>
          <div class="formBtn hand" @click="registCliick">立即注册</div>
        </div>
        <div class="formRight formSub">
          <div class="qrDiv">
            <img src="@/assets/qr.png" />
          </div>
          <div class="formBtn hand">立即下载</div>
        </div>
    </div>
    <div class="lunboDiv divCss">
      <img class="titImg" src="@/assets/tit1.png" />
      <el-carousel :interval="5000" arrow="always" height="7.48rem">
        <el-carousel-item v-for="item in bannerArr" :key="item">
          <img class="lbItem" :src="item" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="descDiv divCss">
      <img class="titImg" src="@/assets/tit2.png" />
      <div class="descCon">
        <div>
          <p>兼职翻译</p>
          <div>在这里，翻译不再是专业人士的专属，而是每个人触手可及的赚钱机会！我们的兼职翻译功能为你搭建起与 全球需求方的桥梁，无论你是精通多语的自由译者，还是想利用语言特长赚外快的上班族、学生党，都能轻 松找到适合自己的翻译任务。</div>
        </div>
        <div>
          <p>小语种学习</p>
          <div>开启小语种学习功能，就像拥有一位 24 小时在线的私人语言导师，带你轻松踏入陌生又迷人的语言世界！ 无论你是为了留学、旅游、职场发展，还是单纯出于对异国文化的热爱，我们都能为你量身定制学习计划。</div>
        </div>
        <div>
          <p>话题分享</p>
          <div>在话题分享功能板块，这里是全球语言爱好者的精神家园，是思维碰撞、灵感迸发的交流圣地！无论你是翻 译达人、语言学习者，还是对多元文化充满好奇的探索者，都能找到属于自己的一方天地。</div>
        </div>
      </div>
    </div>
    <div class="bottomDiv divCss">
      <div class="one hand" @click="copyLike()">立即下载</div>
      <div class="two hand" @click="scrollToTop">立即注册</div>
    </div>
  </div>
</template>
<script>
import { sendsms,register } from '@/util/http'
export default {
  data(){
    return{
        phone:'',
        pwd:'',
        codeVal:'',
        getCodeNum: 5,
        getCodeBlo: false,
        count: '',
        bannerArr:[
            require('@/assets/lb1.png'),
            require('@/assets/lb2.png'),
            require('@/assets/lb3.png'),
        ]
    }
  },
  created() {
    this.setRemUnit()// 初始化
    window.addEventListener('resize', this.setRemUnit)// 监听窗口变化
  },
  mounted() {},
  methods:{
    setRemUnit() {// 设置 rem 基准值
      const designWidth = 1920// 设计稿宽度1920
      const deviceWidth = document.documentElement.clientWidth || window.innerWidth// 当前设备宽度
      const ratio = deviceWidth / designWidth// 计算比例
      document.documentElement.style.fontSize = ratio * 100 + 'px'// 设置 html font-size，一般取 100px 作为基准方便换算
    },
    copyLike(){//复制成功
      this.$notify.info({
        message: '下载链接已复制'
      });
      navigator.clipboard.writeText('cat.nyackuajing.com/download')
    },
    scrollToTop() {//回到顶部
      window.scrollTo({
        top:650,
        behavior: 'smooth' // 平滑滚动
      });
    },
    async registCliick(){//注册
      if (this.phone == '') {
        this.$notify.info({
          type: 'warning',
          message:'手机号不能为空',
          offset: 100
        });
        return
      }
      if (this.codeVal == '') {
        this.$notify.info({
          type: 'warning',
          message:'验证码不能为空',
          offset: 100
        });
        return
      }
      if (this.pwd == '') {
        this.$notify.info({
          type: 'warning',
          message:'密码不能为空',
          offset: 100
        });
        return
      }
      await register({mobile: this.phone,password:this.pwd,code:this.codeVal}).then(res=>{
        console.log(res.msg)
        this.$notify.info({
          type: 'warning',
          message:res.msg,
          offset: 100
        });
      }).catch(err=>{
        console.log(err.msg)
        this.$notify.info({
          type: 'warning',
          message:err.msg,
          offset: 100
        });
      })
    },
    async getCode() {
      if (this.phone == '') {
        this.$notify.info({
          type: 'warning',
          message:'手机号不能为空',
          offset: 100
        });
        return
      }
      const res = await sendsms({mobile: this.phone})//1：注册，2：登录，3：修改密码
      this.loading = true;
      try {
        setTimeout(() => {
          this.loading = false;
          this.codeVal = res.smsCode
          this.$notify.info({
            // showClose: true,
            type: 'warning',
            message:'验证码已发送',
            offset: 100
          });
          this.getCodeNum = 60
          this.countDown()
        }, 500)
      } catch {
      }
    },
    countDown() {//倒计时
      this.getCodeBlo = true
      this.setInterval = setInterval(() => {
        if (this.getCodeNum >= 1) {
          this.getCodeNum--
        } else {
          clearInterval(this.setInterval)
        }
      }, 1000)
    },
  }
}
</script>

<style scoped lang="scss">
.indexBg{
  background: url("@/assets/bg.png");
  background-size: 100%;
  background-repeat: no-repeat;
  .divCss{
    padding:0.5rem 3.6rem;
    box-sizing: border-box;
    //border: solid 1px;
  }
  .logoCss{
    border-bottom: #fde9e9 solid 1px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 4px 4px 0px rgba(230,33,41,0.06);
    img{
      width:2rem;
      height:1rem;
    }
  }
  .btnDiv{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding:0.2rem 1rem;
    box-sizing: border-box;
    img{
      width:0.95rem;
      height:0.95rem;
      margin:0 0.2rem;
    }
    .more-service {
      position: relative;
      display: flex;
      align-items: center;
      cursor: pointer; /* 鼠标悬停显示手型 */
      color: #fb6162; /* 文字颜色 */
      font-size: 0.19rem; /* 文字大小，根据需要调整 */
      margin-left:0.3rem;
      background: #fff;
      padding: 0.16rem 0.2rem;
      border-radius: 0.06rem;
      box-shadow: 0rem -0.01rem 0.1rem 2px #e7e7e7;
    }

    /* 下拉框样式 */
    .service-dropdown {
      position: absolute; /* 相对于 .topImg 定位 */
      top:0.57rem; /* 位于按钮正下方 */
      left:0%;
      padding: 0.15rem 0.31rem;
      background: #fff;
      border-radius: 0.04rem;
      box-shadow: 0 0.02rem 0.1rem rgba(0,0,0,0.1); /* 阴影效果 */
      display: none; /* 默认隐藏 */
      z-index: 100; /* 确保在其他元素上方 */
      box-shadow: 0rem 0.05rem 0.1rem 2px #e7e7e7;

      p {
        //margin: 0 0 0.2rem 0;
        font-weight: bold;
        color: #3e3e3e;
        min-width: 0.2rem; /* 下拉框宽度 */
      }

      a {
        display: block; /* 每个链接占一行 */
        padding: 0.1rem 0;
        color: #3e3e3e;
        text-decoration: none;

        &:hover {
          color: #fb6162; /* hover 颜色 */
        }
      }
    }

    /* 鼠标悬浮时显示下拉框 + 箭头旋转 */
    .more-service:hover .service-dropdown {
      display: block;
    }
  }
  .bannerDiv{
    display: flex;
    align-items: center;
    padding:0 2.6rem;
    box-sizing: border-box;
    .bLeft{

      img{
        width:1.6rem;
        height:0.4rem;
      }
      p{
        color: #380000;
        font-size:0.64rem;
        font-weight: 600;
        margin-bottom:0.3rem;
      }
      div{
        width:4.5rem;
        background: linear-gradient( 90deg, #FF91CA 0%, #E62129 100%);
        border-radius:0.8rem;
        color: #FFFFFF;
        font-size: 0.3rem;
        text-align: center;
        line-height:0.55rem;
      }
    }
    .bRight img{
      width:6rem;
      height: 6.15rem;
      margin-left:1.56rem;
    }
  }
  .formDiv{
    display: flex;
    justify-content: space-between;
    .formLeft{
        background-image: url("@/assets/formOne.png");
    }
    .formRight{
      background-image: url("@/assets/formTwo.png");
    }
    .formSub{
      padding-top: 2.2rem;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      height:4.2rem;
      width:5rem;
      background-size: 100%;
      background-repeat: no-repeat;
    }
    .fInp{
      display: flex;
      width:3.58rem;
      height:0.56rem;
      background: #FFFFFF;
      border-radius: 50px;
      margin:0.09rem 0;
      overflow: hidden;
      padding:0.1rem 0.2rem;
      box-sizing: border-box;
      input{
        width: 100%;
        border: none;
        &::placeholder {
          font-size: 0.15rem;
        }
        &::-webkit-input-placeholder {
          font-size: 0.15rem;

        }
        &::-moz-placeholder {
          font-size: 0.15rem;

        }
        &:-ms-input-placeholder {
          font-size: 0.15rem;

        }
      }

    }
    .codeInp{
      input{
        width:50%;

      }
      .codeDiv{
        width:50%;
        font-size: 0.23rem;
        color: #d6343c;
        text-align: right;
        line-height: 0.4rem;
        span{}
      }
    }
    .qrDiv{
      width:2.2rem;
      height: 2.2rem;
      border-radius:0.2rem;
      border: 2px solid #E62129;
      overflow: hidden;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .formBtn{
      background-image: url("@/assets/submit.png");
      background-size: 100%;
      background-repeat: no-repeat;
      color: #fff;
      width:4rem;
      height:1.4rem;
      font-size: 0.4rem;
      line-height:0.92rem;
      text-align: center;
      //margin-top: 0.2rem;
    }
  }
  .titImg{
    width:10rem;
    height:1.17rem;
  }
.lunboDiv{
  text-align: center;
  .lbItem{
    width:12rem;
    height:7.4rem;
  }
}
  .descDiv{
    text-align: center;
    .descCon{
      width:12rem;
      height:7.4rem;
      background-image: url("@/assets/bor.png");
      background-repeat: no-repeat;
      background-size: 100%;
      padding:0.85rem 0.36rem;
      box-sizing: border-box;
    }
    .descCon div{
      color: #380000;
      p{
        width:3.17rem;
        height:0.79rem;
        background-image: url("@/assets/tit.png");
        background-size: 100%;
        background-repeat: no-repeat;
        font-size:0.36rem;
        line-height: 0.8rem;
      }
      div{
        font-size:0.24rem;
        margin:0.2rem 0 0.3rem 0;
        text-align: left;
      }
    }
  }
  .bottomDiv{
    display: flex;
    align-items: center;
    justify-content: space-around;
    div{
      width:4.7rem;
      height:2.23rem;
      text-align: center;
      line-height:1.25rem;
      font-size:0.48rem;
      color: #fff;
      background-size: 100%;
      background-repeat: no-repeat;
    }
    .one{
      background-image: url("@/assets/btn2.png");
    }
    .two{
      background-image: url("@/assets/btn1.png");
    }
  }
}

:deep .el-carousel__arrow{
  width:1rem!important;
  height:1rem!important;
  font-size: 0 !important;
  background-color: transparent;
  background-image: url("@/assets/right.png")!important;
  background-size: 100%;
  background-repeat: no-repeat;
  border-radius:0rem !important;
}
:deep .el-carousel__arrow:first-child{
  background-image: url("@/assets/lfet.png")!important;
}
</style>